module.exports = {"TAG_DEFAULT_INPUT_PLACEHOLDER":"Anda telah mencapai batas elemen","TAG_ADD_BUTTON":"Tambahkan","TAG_INVALID_VALUE":"Nilai invalid"}